import React from "react";
import { useTranslation } from "react-i18next";
import InfoRow from "./InfoRow";
import InfoSection from "./InfoSection";
import { useSelector } from "react-redux";
import { selectSupplierInfo } from "../../../../store/slices/supplierInfoSlice";
import { useSectionNumbering } from "../hooks/useSectionNumbering";

const CorrectionsSection = () => {
    const { t } = useTranslation();
    const { sectionNumbers } = useSectionNumbering();
    const supplierInfo = useSelector(selectSupplierInfo);
    const { amounts } = supplierInfo || {
        amounts: {},
    };
    const {
        defectsDeductionAmount,
        damageAmount,
        counterclaimsAmount,
        provisionalRetentionAmount,
        penaltyAmount,
        correctionAmount,
    } = amounts || {
        defectsDeductionAmount: 0,
        damageAmount: 0,
        counterclaimsAmount: 0,
        provisionalRetentionAmount: 0,
        penaltyAmount: 0,
        correctionAmount: 0,
    };

    return (
        <InfoSection>
            <InfoRow
                label={`${sectionNumbers.defectsDeduction}. ${t("supplier-info.defects-deduction")}`}
                value={defectsDeductionAmount}
                isNegative={defectsDeductionAmount < 0}
                name="defectsDeduction"
                suffix="€"
            />
            <InfoRow
                label={`${sectionNumbers.damage}. ${t("supplier-info.damage")}`}
                value={damageAmount}
                isNegative={damageAmount < 0}
                name="damage"
                suffix="€"
            />
            <InfoRow
                label={`${sectionNumbers.counterclaims}. ${t("supplier-info.counterclaims")}`}
                value={counterclaimsAmount}
                isNegative={counterclaimsAmount < 0}
                name="counterclaims"
                suffix="€"
            />
            <InfoRow
                label={`${sectionNumbers.provisionalRetention}. ${t("supplier-info.provisional-retention")}`}
                value={provisionalRetentionAmount}
                isNegative={provisionalRetentionAmount < 0}
                name="provisionalRetention"
                suffix="€"
            />
            <InfoRow
                label={`${sectionNumbers.penalty}. ${t("supplier-info.penalty")}`}
                value={penaltyAmount}
                isNegative={penaltyAmount < 0}
                name="penalty"
                suffix="€"
            />
            <InfoRow
                label={`${sectionNumbers.correctionAmount}. ${t("supplier-info.correction-amount")}`}
                value={correctionAmount}
                isNegative={correctionAmount < 0}
                name="correction"
                suffix="€"
            />
        </InfoSection>
    );
};

export default CorrectionsSection;
